import { ReviewSortCriteriaValue } from '@/apis';

export const campaignKey = {
  all: ['campaigns'] as const,
  campaign: (campaign_id: string) => [...campaignKey.all, campaign_id, 'campaign'] as const,
  campaignV2: (campaign_id: string) => [...campaignKey.all, campaign_id, 'campaignV2'] as const,
  campaignReviews: (campaign_id: number, sort_by: ReviewSortCriteriaValue) =>
    [...campaignKey.all, 'campaignReviews', campaign_id, sort_by] as const,
};
